module.exports = __webpack_public_path__ + "img/img-avatar-01.0531392f.png";